export enum QueryKeys {
  tollingAdminAccess = 'tollingAdminAccess',

  billingDetailsList = 'billingDetailsList',
  billingDetailsInfo = 'billingDetailsInfo',

  paymentClaimsList = 'paymentClaimsList',
  paymentClaimsInfo = 'paymentClaimsInfo',

  passagesList = 'passagesList',
  passageInfo = 'passageInfo',
  passageEditHistory = 'passageEditHistory',

  receiptsList = 'receiptsList',
  receiptInfo = 'receiptInfo',

  transactionsList = 'transactionsList',
  transactionInfo = 'transactionInfo',

  iTicketList = 'iTicketList',
  iTicketInfo = 'iTicketInfo',

  auditLog = 'auditLog',

  exceptionLists = 'exceptionLists',
  exceptionListInfo = 'exceptionListInfo',
  exceptionListChunks = 'exceptionListChunks',

  contractIssuerLists = 'contractIssuerLists',
  contractIssuerListInfo = 'contractIssuerListInfo',

  actionLists = 'actionLists',
  actionListInfo = 'actionListInfo',
  actionListStatus = 'actionListStatus',

  efcContextDataOutbound = 'efcContextDataOutbound',
  efcContextDataInbound = 'efcContextDataInbound',

  oresundsbronData = 'oresundsbronData',

  localAgreementsList = 'localAgreementsList',
  localAgreementDetails = 'localAgreementDetails',

  tollServiceProviderList = 'tollServiceProviderList',
  tollServiceProviderInfo = 'tollServiceProviderInfo',
}
